module.exports = __webpack_public_path__ + "img/mapfre-sigorta.9dd3960a.jpg";